import IndexHarmonizationReportItem from "../model/IndexHarmonizationReportItem";

const IndexHarmonizationReportMapper = (item: string[]) => {
  const [indexType, parentName, harmonizedLabel, ...organisationIndexNames] =
    item;
  return IndexHarmonizationReportItem({
    indexType,
    parentName,
    harmonizedLabel,
    organisationIndexNames,
  });
};

export default IndexHarmonizationReportMapper;
